import { render } from "./ImagesSlider.vue?vue&type=template&id=7f068631&scoped=true&ts=true"
import script from "./ImagesSlider.vue?vue&type=script&lang=ts"
export * from "./ImagesSlider.vue?vue&type=script&lang=ts"

import "./ImagesSlider.vue?vue&type=style&index=0&id=7f068631&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f068631"]])

export default __exports__